import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { AdvertisementModel } from '../models/advertisement.model';
import { ConfigurationService } from '../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AdvertisementService {
  private readonly http = inject(HttpClient);
  private readonly configSvc = inject(ConfigurationService);


  private backUrl;

  constructor() {
    this.backUrl = `${this.configSvc.productApiUrl}api/Advertisements`;
  }

  get(): Observable<Array<AdvertisementModel>> {
    return this.http.get<Array<AdvertisementModel>>(`${this.backUrl}`);
  }

  getAdvertisement(advertisementId: string): Observable<AdvertisementModel> {
    return this.http.get<AdvertisementModel>(`${this.backUrl}/${advertisementId}`);
  }

  post(model: AdvertisementModel): Observable<any> {
    return this.http.post(`${this.backUrl}`, model);
  }

  patch(model: AdvertisementModel): Observable<any> {
    return this.http.patch(`${this.backUrl}/${model.id}`, model);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.backUrl}/${id}`);
  }
}
